import React from 'react';
import {connect} from 'react-redux';

import {firstHandicapCondition, secondHandicapCondition} from 'rendering-commons';

import HeaderRate from './../rates/HeaderRate.jsx';

class HandicapOutcome extends React.Component {
    static propTypes = {
        section: React.PropTypes.string.isRequired,
        outcome: React.PropTypes.object,
        gridLocalization: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {section, outcome, gridLocalization} = this.props;

        if (outcome === undefined) {
            return (
                <span className="cell-title-wrapper">
                    <span className="cell cond">{'\u00A0'}</span>
                    <span className="cell rate empty-cell">{'\u00A0'}</span>
                    <span className="cell cond">{'\u00A0'}</span>
                    <span className="cell rate empty-cell">{'\u00A0'}</span>
                </span>
            );
        }

        const outcomeRates = [];

        outcome.get('rates')
            .entrySeq()
            .sortBy((r) => r[0])
            .forEach((r) => {
                outcomeRates.push(r[1]);
            });

        const isBlocked = outcome.get('isBlocked');

        const conditionCls = 'cell cond' + (isBlocked ? ' closed' : '');

        const props = {
            section,
            gridLocalization
        };

        return (
            <span className="cell-title-wrapper">
                <span className={conditionCls}>{firstHandicapCondition(outcome.get('condition'))}</span>
                <HeaderRate key={outcomeRates[0]} id={outcomeRates[0]} {...props} />
                <span className={conditionCls}>{secondHandicapCondition(outcome.get('condition'))}</span>
                <HeaderRate key={outcomeRates[1]} id={outcomeRates[1]} {...props} />
            </span>
        );
    }
}

function select(state, props) {
    const {section, id} = props;
    let outcome;

    if (id && id !== null) {
        outcome = state.application.getIn([section, 'outcomes', id]);
    }

    return {
        section,
        outcome
    };
}

export default connect(select)(HandicapOutcome);



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/header/HandicapOutcome.jsx